// extracted by mini-css-extract-plugin
module.exports = {"container":"Order_container__bqg58","content":"Order_content__rPMlC"};